import { render, staticRenderFns } from "./MapScalePlus.vue?vue&type=template&id=036852ca&"
import script from "./MapScalePlus.vue?vue&type=script&lang=ts&"
export * from "./MapScalePlus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports